var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegularHelpPage',{attrs:{"AppThemeSetting":_vm.AppThemeSetting,"nameOfPage":'CoursesPage'}})}
var staticRenderFns = []

export { render, staticRenderFns }